import { Col, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';
import phoneSchema from './phoneSchema.png';

const breakpoints = {
  sm: '480px',
  md: '768px',
  lg: '1024px',
  xl: '1280px'
};

const MessageWrapper = styled.div`
  position: relative; // Added position
  z-index: 2; // Added z-index
  /* Notification container */
  .notification {
    display: flex;
    align-items: flex-start;
    background-color: #f5f5f5;
    border-radius: 13px;
    padding: 10px;
    margin-left: 12%;
    margin-right: 12%;
    margin-top: 300px;
    margin-bottom: 20px;
  }

  /* Notification content */
  .notification-content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    margin-left: 10px;
  }

  /* Notification header */
  .notification-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  /* Notification title */
  .notification-title {
    font-size: 15px;
    font-weight: bold;
  }

  /* Notification timestamp */
  .notification-timestamp {
    font-size: 13px;
    color: gray;
  }

  /* Notification message */
  .notification-message {
    font-size: 15px;
    line-height: 18px;
    margin-top: 5px;
    max-width: 300px;
  }
`;
const ScreenDate = styled.div`
  position: absolute;
  z-index: 2; // Added z-index
  top: 25%;
  right: 30%;
  font-size: 16px;
  padding: 2px 5px;
  border-radius: 5px;
  color: black;
  @media (max-width: ${breakpoints.sm}) {
    top: 20%;
    right: 20%;
    font-size: 8px;
  }
  @media (max-width: ${breakpoints.md}) {
    top: 25%;
    right: 30%;
    font-size: 12px;
  }
  @media (max-width: ${breakpoints.lg}) {
    top: 25%;
    right: 30%;
    font-size: 16px;
  }
  @media (max-width: ${breakpoints.xl}) {
    top: 25%;
    right: 30%;
    font-size: 16px;
  }
`;

export const PushPreview = (props: {
  date?: string;
  time?: string;
  title?: string;
  message?: string;
}): JSX.Element => {
  return (
    <Row justify="center">
      <Col
        span={22}
        style={{
          paddingTop: '20px',
          maxWidth: '400px',
          overflow: 'hidden'
        }}
      >
        <img
          alt="iMessage Mock"
          style={{
            width: '100%',
            position: 'absolute',
            marginBottom: '12px',
            filter: 'opacity(0.87)',
            zIndex: 1 // Added z-index
          }}
          src={phoneSchema}
        />{' '}
        <ScreenDate>{props.date}</ScreenDate>
        <div
          className="screen-time"
          style={{
            position: 'absolute',
            zIndex: 2, // Added z-index
            top: '35%',
            right: '35%',
            padding: '2px 5px',
            borderRadius: '5px',
            fontSize: '48px',
            color: 'black',
            fontWeight: 'bold'
          }}
        >
          {props.time}
        </div>
        <MessageWrapper>
          <div className="notification">
            <div className="notification-content">
              <div className="notification-header">
                <div className="notification-title">{props.title}</div>
                <div className="notification-timestamp">now</div>
              </div>
              <div className="notification-message">{props.message}</div>
            </div>
          </div>
        </MessageWrapper>
      </Col>
    </Row>
  );
};
